var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{staticClass:"search-bar-entities",attrs:{"label":"Search","clearable":""},on:{"input":_vm.performSearch},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }